import 'core-js/stable';
import 'core-js/es';
import 'regenerator-runtime/runtime'
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';


import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom'
import routes from '@/router'
import RouterView from '@/router/RouterView'
import { Provider } from 'react-redux'
import history from '@/utils/history'
import store from '@/store';
import './styles/index.less';
import 'antd/dist/antd.variable.min.css';
import reportWebVitals from './reportWebVitals';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN'
import moment from 'moment';
import 'moment/locale/zh-cn';
import autofit, { elRectification } from 'autofit.js'

moment.locale('zh-cn')

ReactDOM.render(
  <ConfigProvider locale={zhCN}>
    <Provider store={store}>
      <BrowserRouter history={history}>
        <RouterView routes={routes}  />
      </BrowserRouter>
    </Provider>
  </ConfigProvider>,
  document.getElementById('root')
);

reportWebVitals();


const debounce = (fn, delay) => {
  let timer
   return (...args) => {
     if (timer) {
       clearTimeout(timer)
     }
     timer = setTimeout(() => {
       fn(...args)
     }, delay)
   }
}
  
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver{
   constructor(callback) {
     callback = debounce(callback, 200);
     super(callback);
   }
}


autofit.init({
  dh: 1080,
  dw: 1920,
  el:"body",
  resize: true,
  // ignore: [
  //   {
  //     el: '.login-wrap'
  //   }
  // ]
}, false)

document.querySelector('body').style.backgroundColor = `#034A87`


// const handleScreenAuto = () => {
//   const designDraftWidth = 1920;//设计稿的宽度
//   const designDraftHeight = 1080;//设计稿的高度
//   //根据屏幕的变化适配的比例
//   const scale = document.documentElement.clientWidth / document.documentElement.clientHeight < designDraftWidth / designDraftHeight ?
//       (document.documentElement.clientWidth / designDraftWidth) :
//       (document.documentElement.clientHeight / designDraftHeight);
//   // const scale = designDraftWidth / designDraftHeight
//   //缩放比例
//   document.querySelector('body').style.transform = `scale(${scale})`
//   document.querySelector('body').style.width = designDraftWidth + 'px'
//   document.querySelector('body').style.height = designDraftHeight + 'px'
// }

// handleScreenAuto();
// window.onresize = () => handleScreenAuto();